import homeScreen from "../assets/images/coming-soon/Faq/home-screen.png";
import cardScreen from "../assets/images/coming-soon/Faq/cards.png";
import creditCard from "../assets/images/coming-soon/Faq/credit-cards.png";

export const FaqList = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 1 year up to 8 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content:
      "Minimum financing amount is RM10,000 and maximum financing amount is RM50,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListHighIncome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 1 year up to 8 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content:
      "Minimum financing amount is RM1,000 and maximum financing amount is RM250,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];

export const FaqListUmrah = [
  {
    id: 0,
    title: "Apakah kontrak Syariah yang digunakan?",
    content: "Kontrak Syariah yang berkenaan ialah Komoditi Murabahah.",
  },
  {
    id: 1,
    title: "Apakah tempoh pembiayaan minimum dan maksimum?",
    content:
      "Tempoh pembiayaan minimum ialah 1 tahun, dan tempoh pembiayaan maksimum ialah 8 tahun, tertakluk kepada terma dan syarat.",
  },
  {
    id: 2,
    title: "Apakah jumlah pembiayaan minimum dan maksimum?",
    content:
      "Jumlah pembiayaan minimum ialah RM10,000 dan jumlah pembiayaan maksimum ialah RM50,000, tertakluk kepada terma dan syarat.",
  },
  {
    id: 3,
    title: "Adakah perlindungan takaful / insurans wajib?",
    content: "Perlindungan takaful / insurans tidak diwajibkan.",
  },
  {
    id: 4,
    title:
      "<span>Bagaimana memohon Pembiayaan <span className='no-wrap'>Peribadi-<i>i</i> ?</span></span>",
    content:
      "<p>Anda boleh datang terus ke cawangan terdekat, atau hubungi talian perkhidmatan pelanggan kami di +603 2332 6000 atau tinggalkan butiran hubungan anda dalam pautan <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>ini</a>, wakil bank kami akan menghubungi untuk membantu anda.</p>",
  },
  {
    id: 5,
    title: "Bagaimana bayar ansuran bulanan?",
    content:
      "Anda dikehendaki mendepositkan ansuran bulanan dalam akaun pembiayaan pada atau sebelum tarikh ansuran matang sehingga penyelesaian penuh pembiayaan.",
  },
  {
    id: 6,
    title:
      "Bagaimana jika saya menjelaskan sepenuhnya pembiayaan sebelum akhir tempoh pembiayaan?",
    content:
      "Anda boleh membuat penjelasan awal pada bila-bila masa dalam tempoh pembiayaan. Rebat atau Ibra’ akan diberikan sejajar dengan garis panduan Bank Negara Malaysia dan garis panduan Bank.",
  },
  {
    id: 7,
    title: "Bagaimana saya boleh menghubungi alrajhi bank Malaysia?",
    content:
      "Untuk maklumat lanjut, sila hubungi Perunding Khidmat Pelanggan 24 Jam kami di +603 2332 6000, atau emel ke customersupport@alrajhibank.com.my.",
  },
];
export const FaqListUmrahHighIncome = [
  {
    id: 0,
    title: "Apakah kontrak Syariah yang digunakan?",
    content: "Kontrak Syariah yang berkenaan ialah Komoditi Murabahah.",
  },
  {
    id: 1,
    title: "Apakah tempoh pembiayaan minimum dan maksimum?",
    content:
      "Tempoh pembiayaan minimum ialah 2 tahun, dan tempoh pembiayaan maksimum ialah 8 tahun, tertakluk kepada terma dan syarat.",
  },
  {
    id: 2,
    title: "Apakah jumlah pembiayaan minimum dan maksimum?",
    content:
      "Jumlah pembiayaan minimum ialah RM1,000 dan jumlah pembiayaan maksimum ialah RM250,000, tertakluk kepada terma dan syarat.",
  },
  {
    id: 3,
    title: "Adakah perlindungan takaful / insurans wajib?",
    content: "Perlindungan takaful / insurans tidak diwajibkan.",
  },
  {
    id: 4,
    title:
      "<span>Bagaimana memohon Pembiayaan <span className='no-wrap'>Peribadi-<i>i</i> ?</span></span>",
    content:
      "<p>Anda boleh datang terus ke cawangan terdekat, atau hubungi talian perkhidmatan pelanggan kami di +603 2332 6000 atau tinggalkan butiran hubungan anda dalam pautan <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>ini</a>, wakil bank kami akan menghubungi untuk membantu anda.</p>",
  },
  {
    id: 5,
    title: "Bagaimana bayar ansuran bulanan?",
    content:
      "Anda dikehendaki mendepositkan ansuran bulanan dalam akaun pembiayaan pada atau sebelum tarikh ansuran matang sehingga penyelesaian penuh pembiayaan.",
  },
  {
    id: 6,
    title:
      "Bagaimana jika saya menjelaskan sepenuhnya pembiayaan sebelum akhir tempoh pembiayaan?",
    content:
      "Anda boleh membuat penjelasan awal pada bila-bila masa dalam tempoh pembiayaan. Rebat atau Ibra’ akan diberikan sejajar dengan garis panduan Bank Negara Malaysia dan garis panduan Bank.",
  },
  {
    id: 7,
    title: "Bagaimana saya boleh menghubungi alrajhi bank Malaysia?",
    content:
      "Untuk maklumat lanjut, sila hubungi Perunding Khidmat Pelanggan 24 Jam kami di +603 2332 6000, atau emel ke customersupport@alrajhibank.com.my.",
  },
];

export const FaqListTdi = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 1 year up to 7 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content:
      "Minimum financing amount is RM5,000 and maximum financing amount is RM500,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListTdiHighIncome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 1 year up to 7 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content:
      "Minimum financing amount is RM5,000 and maximum financing amount is RM500,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];

export const FaqListEbs = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 2 years up to 8 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content:
      "Minimum financing amount is RM5,000 and maximum financing amount is RM80,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListEbsHighIncome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 2 years up to 10 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content:
      "Minimum financing amount is RM5,000 and maximum financing amount is RM250,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];

export const FaqListCCSPSD = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 2 years up to 8 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content:
      "Minimum financing amount is RM5,000 and maximum financing amount is RM80,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListCCSPSDHighIncome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 2 years up to 10 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content:
      "Minimum financing amount is RM5,000 and maximum financing amount is RM250,000, subject to terms and conditions.",
  },
  {
    id: 3,
    title: "Is takaful / insurance coverage compulsory?",
    content: "The takaful / insurance coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Personal <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];

export const FaqListBusiness = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 5 years up to 25 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "The Minimum financing amount is RM50,000.",
  },
  {
    id: 3,
    title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
    content: "The Mortgage Reducing Term Takaful (MRTT) coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Home <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListPFHome = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 5 years up to 35 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "The Minimum financing amount is RM50,000.",
  },
  {
    id: 3,
    title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
    content: "The Mortgage Reducing Term Takaful (MRTT) coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Home <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];
export const FaqListPFHomeOne = [
  {
    id: 0,
    title: "What is the Shariah contract applicable?",
    content: "The applicable Shariah contract is Commodity Murabahah.",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure?",
    content:
      "The financing tenure is ranging from minimum 5 years up to 35 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum and maximum financing amount?",
    content: "The Minimum financing amount is RM50,000.",
  },
  {
    id: 3,
    title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
    content: "The Mortgage Reducing Term Takaful (MRTT) coverage is optional.",
  },
  {
    id: 4,
    title:
      "<span>How to apply Home <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
    content:
      "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
  },
  {
    id: 7,
    title: "How do I contact alrajhi bank Malaysia?",
    content:
      "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
  },
];

export const FaqListBusinessPremiseFinancing = [
  {
    id: 0,
    title: "What is the alrajhi bank Malaysia Business Premises Financing-<em>i</em>?",
    content: "The Business Premises Financing-i is a financing facility designed to assist businesses in purchasing commercial properties. This includes both completed properties and properties that are currently under construction. The financing utilizes a trade line facility, with the profit rate calculated on a variable basis. The Shariah contract applicable to this product is Commodity Murababah",
  },
  {
    id: 1,
    title: "What is the minimum and maximum tenure offered?",
    content:
      "The financing tenure is ranging from minimum 5 years up to 25 years, subject to terms and conditions.",
  },
  {
    id: 2,
    title: "What is the minimum financing amount?",
    content: "The Minimum financing amount is RM50,000.",
  },
  {
    id: 3,
    title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
    content: "The Mortgage Reducing Term Takaful (MRTT) coverage is optional. However, all customers are strongly encouraged to take up takaful/insurance coverage.",
  },
  {
    id: 4,
    title: "How do I apply for a Business Premises Financing-i?",
    content:
      "You can apply by visiting the nearest alrajhi bank Malaysia branch, calling our Customer Care Hotline at +603 2332 6000,  or use the contact form below.",
  },
  {
    id: 5,
    title: "How do I pay for the monthly installment?",
    content:
      "You'll need to ensure that your monthly instalment amount is deposited into your financing account on or before the due date each month, until the financing is fully settled.",
  },
  {
    id: 6,
    title: "What if I fully settle the financing before its maturity?",
    content:
      "<div><p>You may choose to fully settle the financing before the maturity date. If you do so within the first five years from the date of the initial disbursement, the Bank reserves the right to claim any actual entry costs incurred.</p><p>A rebate will be provided by the Bank in accordance with the guidelines set forth by Bank Negara Malaysia and our internal rebate (Ibra') policy.</p><p>After completing each sale transaction, the customer may pay the full Bank sale price or any portion of the outstanding amount, as accepted at the Bank's discretion.</p></div>",
  },
  {
    id: 7,
    title: "Are there any fees or charges involved?",
    content:
      "Yes. For the avoidance of doubt, please be aware that you will be responsible for all professional fees, applicable taxes (including but not limited to sales and service tax (SST)), and any out-of-pocket expenses incurred. Additionally, you will bear any other fees, expenses, or recourse related to this product.",
  },
];

export const FAQComingSoon = [
  {
    id: 1,
    title: "How do I set up the app?",
    content:
      "To set up the app, download it from the App Store or Google Play, install it, and follow the on-screen instructions to register or log in using your Al Rajhi Bank Malaysia account details.",
  },
  {
    id: 2,
    title: "Is the app secure?",
    content:
      "Yes, the app is designed with your security in mind. We use industry-standard encryption and follow best practices to help protect your data.",
  },
  {
    id: 3,
    title: "Is the app free?",
    content:
      "Yes, the app is completely free to download and use. However, standard mobile data charges may apply depending on your carrier.",
  },
  {
    id: 4,
    title: "How do I activate my new alrajhi bank Malaysia card on the app?",
    content:
      "After logging in, go to the “Cards” section, select “Activate Card,” and follow the prompts. You may need to enter the card number and verify your identity.",
  },

  {
    id: 5,
    title: "How do I check my alrajhi bank Malaysia credit card balance?",
    content:
      `To check your credit card balance: <ol><li>Open the app and log in.<div className='py-4'><img src=${homeScreen} alt='Home Screen Image' /></div></li><li>Tap on “Account” at the bottom of the screen.<div className='py-4'><img src=${cardScreen} alt='Home Screen Image' /></div></li><li>Tap on “Cards”. Select your credit card – your balance will be displayed right at the top.<div className='py-4'><img src=${creditCard} alt='Home Screen Image' /></div></li></ol>`,
  },
  {
    id: 6,
    title: "What should I do if I can’t log on to the app?",
    content:
      "If you’re having trouble logging in, try resetting your password or ensuring your internet connection is stable. If the issue persists, contact our support team for assistance.",
  },
  {
    id: 7,
    title: "How do I manage my online banking limits?",
    content:
      "Go to “Settings” in the app, select “Transaction Limits,” and adjust your daily and per-transaction limits according to your preference.",
  },
  {
    id: 8,
    title: "How do I contact ARBM?",
    content:
      "For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below: <br />+603 2332 6000, <br />customersupport@alrajhibank.com.my",
  },
];
